var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.01468H21V25.0147H1V7.01468Z",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.0147L29.5533 22.2907C29.7058 22.3668 29.8752 22.4027 30.0454 22.395C30.2156 22.3872 30.381 22.3361 30.526 22.2465C30.6709 22.1569 30.7905 22.0317 30.8735 21.8828C30.9564 21.734 31 21.5664 31 21.396V10.632C31.0001 10.4616 30.9567 10.294 30.8737 10.1451C30.7907 9.99623 30.671 9.87106 30.526 9.78152C30.381 9.69198 30.2155 9.64103 30.0453 9.63354C29.875 9.62604 29.7057 9.66224 29.5533 9.73869L25 12.0147",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.771adfbe79abfb78b7599bc9c7a9e6c7.svg";
export { ForwardRef as ReactComponent };